import { render } from "./AlertDesktopComponent.vue?vue&type=template&id=590f8c6e"
import script from "./AlertDesktopComponent.vue?vue&type=script&lang=js"
export * from "./AlertDesktopComponent.vue?vue&type=script&lang=js"

import "./AlertDesktopComponent.vue?vue&type=style&index=0&id=590f8c6e&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__